import api from "../../../api";

export async function captureDurableFacilitatedSession({
  sourceRuntimeId,
  sourceRuntimeCode,
}) {
  const response =
    await api.post("/durable-facilitated-sessions/capture", {
      sourceRuntime: {
        type: "interactiveSession",
        id: sourceRuntimeId,
        code: sourceRuntimeCode,
      },
    });

  return response.data;
}

export async function listDurableFacilitatedSessions() {
  const response =
    await api.get("/durable-facilitated-sessions");

  return response.data?.durableSessions || [];
}

export async function getDurableFacilitatedSession(
  durableSessionId
) {
  const response =
    await api.get(
      `/durable-facilitated-sessions/${durableSessionId}`
    );

  return response.data?.durableSession || null;
}
